import { Path, withLeaflet } from 'react-leaflet'

import L from 'leaflet'
import proj4 from 'proj4'
import 'proj4leaflet'

import { epsg, proj } from './BNGMap'

class GeoJsonHover extends Path {
  updateLeafletElement (from, props) {
    this.geoJson.setStyle((feature) => {
      if (feature.properties.name === props.selected || feature.properties.name === props.hovered) {
        return {
          color: '#5511ff',
          fillOpacity: 0.5,
          opacity: 1
        }
      } else {
        return {
          opacity: 0,
          fillOpacity: 0
        }
      }
    })
  }

  createLeafletElement (props) {
    proj4.defs(epsg, proj)
    this.geoJson = L.Proj.geoJson(props.data, {
      style: () => {
        return {
          opacity: 0.0,
          fillOpacity: 0.0
        }
      }
    })
    return this.geoJson
  }
}

export default withLeaflet(GeoJsonHover)
